<template >
    <div>
        <div>
            <Header />
            <div>
                <div class="title">
                    <div class="navTitle">
                        <WorkflowBreadcrumb :exhibitName="exhibitName" current="associate" />
                        <span class="info-icon">
                            <q-btn flat round dense icon="info">
                                <q-popup-proxy ref="popup">
                                    <q-card>
                                        <q-card-section>
                                            A chaque fichier qui compose votre page intermédiaire , vous
                                            pouvez lier
                                            d'autres fichiers que vous pourrez valoriser en les animant
                                        </q-card-section>
                                    </q-card>
                                </q-popup-proxy>
                            </q-btn>
                        </span>

                    </div>

                </div>
                <div class="navButtons">
                    <q-btn color="pink-10" style="margin-left: 7%" @click="navigateBack">Retour</q-btn>
                    <div>
                        <q-btn label="Prévisualiser l'exposition en ligne" color="blue-grey-4" @click="openNewTab" />
                    </div>
                    <div style="margin-right: 7%">
                        <q-btn color="deep-purple-4" label="Page intermédiaire suivante" @click="finalSave" />
                    </div>
                </div>

            </div>
            <hr style="margin-bottom: 15px" />
        </div>
        
        <div class="container">
            <div class="column flex-column" v-if="column1">
                <h4><q-icon name="cloud_upload" /> Importer des fichiers objets pour associer aux fichiers de votre page
                    intermédiaire</h4>
                <div
                    class="drop-zone"
                    :class="{ 'drop-zone--active': isDragging }"
                    @dragover.prevent="isDragging = true"
                    @dragenter.prevent="isDragging = true"
                    @dragleave.prevent="isDragging = false"
                    @drop.prevent="onDrop"
                >
                    <q-icon name="cloud_upload" size="48px" :color="isDragging ? 'primary' : 'grey-6'" />
                    <p class="q-mt-sm q-mb-xs" style="font-size: 14px;">
                        Glissez-déposez vos fichiers ici
                    </p>
                    <p class="text-caption text-grey-6 q-mb-sm">
                        (Images, Vidéos, Audios, Documents Word)
                    </p>
                    <q-file
                        v-model="selectedFiles"
                        label="ou cliquez pour sélectionner"
                        outlined
                        dense
                        multiple
                        accept="image/*,video/*,audio/*,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                        @update:model-value="onFilesSelected"
                        style="max-width: 300px;"
                    >
                        <template v-slot:prepend>
                            <q-icon name="attach_file" />
                        </template>
                    </q-file>
                </div>

                <!-- Liste des fichiers sélectionnés -->
                <div v-if="filesToUpload.length > 0" class="q-mt-md">
                    <div class="text-subtitle2 q-mb-sm">{{ filesToUpload.length }} fichier(s) sélectionné(s)</div>
                    <q-list bordered separator class="rounded-borders q-mb-md">
                        <q-item v-for="(f, idx) in filesToUpload" :key="idx" class="q-pa-sm">
                            <q-item-section>
                                <div class="row items-center q-mb-xs">
                                    <q-icon :name="getFileIcon(f.file.name)" class="q-mr-sm" />
                                    <span class="text-weight-medium">{{ f.file.name }}</span>
                                    <q-space />
                                    <q-icon name="close" class="cursor-pointer" color="negative"
                                        @click="filesToUpload.splice(idx, 1)" />
                                </div>
                                <div class="row q-col-gutter-sm">
                                    <div class="col-6">
                                        <q-input v-model="f.title" label="Titre" dense outlined />
                                    </div>
                                    <div class="col-6">
                                        <q-input v-model="f.source" label="Nom de la source" dense outlined />
                                    </div>
                                    <div class="col-6">
                                        <q-input v-model="f.description" label="Description" dense outlined
                                            type="textarea" autogrow />
                                    </div>
                                    <div class="col-6">
                                        <q-input v-model="f.source_url" label="URL de la source" dense outlined />
                                    </div>
                                </div>
                            </q-item-section>
                        </q-item>
                    </q-list>
                    <q-btn @click="importFiles" color="secondary" label="Importer tous les fichiers" :loading="uploading" />
                </div>

                <!-- Progression -->
                <div v-if="uploading" class="q-mt-md">
                    <div class="text-caption q-mb-xs">
                        Fichier {{ uploadCurrent }} / {{ uploadTotal }}
                    </div>
                    <q-linear-progress :value="progress / 100" color="blue" />
                    <div class="text-caption text-center q-mt-xs">{{ progress }}%</div>
                </div>
                <div class="upload-loader" v-if="loading && !uploading">
                    <div class="upload-loader-card">
                        <div class="spinner-container">
                            <div class="spinner-dot"></div>
                            <div class="spinner-dot"></div>
                            <div class="spinner-dot"></div>
                        </div>
                        <p class="upload-loader-text">Importation en cours...</p>
                        <div v-if="uploading" class="progress-container">
                            <div class="progress-bar" :style="{ width: progress + '%' }"></div>
                        </div>
                        <p v-if="uploading" class="progress-text">{{ progress }}%</p>
                    </div>
                </div>
                <q-banner v-if="success" class="app-banner app-banner--success" dense rounded>
                    Données enregistrées
                </q-banner>
                <q-banner v-if="errorBanner" class="app-banner app-banner--error" dense rounded>
                    Erreur dans l'enregistrement
                </q-banner>
                <div class="q-mt-md">
                    <q-btn label="Gérer les fichiers" color="warning" @click="resourcesList = true" />
                    <q-dialog v-model="resourcesList" maximized @hide="getResources(); resourceAssociatorKey++; intermediatePopupKey++">
                        <MediaManager :exhibitId="$store.state.exhibitId" />
                    </q-dialog>
                </div>
            </div>

            <div class="column flex-column" style="flex-basis:600px" v-if="column2">
                <h4><q-icon name="preview" /> Prévisualisation des objets</h4>
                <IntermediatePopup :selectedPointId="selectedPointId" :selectedResource="selectedResource"
                    :key="intermediatePopupKey" />
            </div>

            <!-- Backdrop + Loader de refresh -->
            <div v-if="isRefreshing" class="refresh-backdrop">
                <div class="refresh-loader">
                    <div class="spinner-container">
                        <div class="spinner-dot"></div>
                        <div class="spinner-dot"></div>
                        <div class="spinner-dot"></div>
                    </div>
                    <p class="refresh-text">Mise à jour en cours...</p>
                </div>
            </div>
            <div class="column flex-column" v-if="column3">

                <div class="column-section">
                    <h4>
                        <q-icon :name="isQuizDisplay ? 'quiz' : 'link'" />
                        {{ isQuizDisplay ? "Sélectionnez l'objet qui déclenche le quiz" : "Sélectionnez le fichier sur lequel associer des objets" }}
                    </h4>
                    <ResourceAssociator :selectedPointId="selectedPointId" :associations-disabled="isQuizDisplay" @updateAssociatedResources="reloadComponent"
                        ref="resourceAssociator" :key="resourceAssociatorKey" :pairing-mode="displaySelected === 'avantApres'"
                        @selectedResource="(resource) => handleSelectedResource(resource)" @orderUpdated="reloadComponent"/>
                </div>
                <div class="animation-editor column-section">
                    <div class="animation-editor__header">
                        <div class="animation-editor__title">
                            <q-icon name="auto_fix_high" />
                            <div>
                                <h4>Animer un objet</h4>
                                <span v-if="selectedResource" class="animation-editor__resource">
                                    {{ selectedResource.title || selectedResource.name || 'Objet sélectionné' }}
                                </span>
                            </div>
                        </div>
                    </div>

                    <q-select
                        :options="displayOptions"
                        option-label="label"
                        emit-value
                        map-options
                        outlined
                        v-model="displaySelected"
                        label="Type d'animation"
                        dense
                        class="animation-editor__field"
                    >
                        <template v-slot:prepend>
                            <q-icon name="animation" />
                        </template>
                    </q-select>

                    <div class="overlay-settings">
                        <div class="overlay-settings__top">
                            <div class="overlay-settings__label">
                                <q-icon name="palette" />
                                <span>Fond de l'overlay</span>
                            </div>
                            <q-btn-toggle
                                v-model="bgSource"
                                toggle-color="primary"
                                unelevated
                                class="overlay-settings__toggle"
                                :options="[
                                    { label: 'Couleur', value: 'color' },
                                    { label: 'Image', value: 'image' }
                                ]"
                            />
                        </div>

                        <div class="overlay-settings__body">
                            <q-input
                                v-if="bgSource === 'color'"
                                outlined
                                v-model="bgColor"
                                label="Couleur de fond"
                                dense
                                class="overlay-settings__control"
                            >
                                <template v-slot:prepend>
                                    <div class="color-swatch" :style="{ backgroundColor: bgColor || '#ffffff' }"></div>
                                </template>
                                <template v-slot:append>
                                    <q-icon name="colorize" class="cursor-pointer">
                                        <q-popup-proxy cover transition-show="scale" transition-hide="scale">
                                            <q-color v-model="bgColor" />
                                        </q-popup-proxy>
                                    </q-icon>
                                </template>
                            </q-input>
                            <q-select
                                v-else
                                clearable
                                :options="resources"
                                option-label="title"
                                option-value="id"
                                emit-value
                                map-options
                                outlined
                                dense
                                class="overlay-settings__control"
                                v-model="bgImageId"
                                label="Image de fond"
                            >
                                <template v-slot:prepend>
                                    <q-icon name="image" />
                                </template>
                            </q-select>

                            <div class="overlay-preview" :style="overlayPreviewStyle">
                                <q-icon v-if="bgSource === 'image'" name="image" />
                                <span v-if="bgSource === 'color'">{{ bgColor || 'Aucune couleur' }}</span>
                                <span v-else>{{ selectedBgImageTitle }}</span>
                            </div>
                        </div>
                    </div>

                    <div v-if="displaySelected === 'quiz' || displaySelected === 'quizFullPage'" class="quiz-settings">
                        <q-select
                            clearable
                            :options="quizzes"
                            option-label="title"
                            option-value="id"
                            emit-value
                            map-options
                            outlined
                            dense
                            v-model="quizSelectedId"
                            label="Quiz"
                        >
                            <template v-slot:prepend>
                                <q-icon name="quiz" />
                            </template>
                        </q-select>
                        <q-btn
                            flat
                            color="secondary"
                            label="Gérer les quiz"
                            class="quiz-settings__button"
                            @click="quizManager = true"
                        />
                        <q-dialog v-model="quizManager" maximized @hide="getQuizzes">
                            <QuizManager :exhibitId="$store.state.exhibitId" />
                        </q-dialog>
                    </div>

                    <div class="animation-editor__actions">
                        <q-btn
                            color="secondary"
                            @click="saveStyle"
                            label="Enregistrer"
                            :disable="!selectedResource"
                        />
                    </div>
                </div>


                <q-banner v-if="success" class="app-banner app-banner--success" dense rounded>
                    Données enregistrées
                </q-banner>
                <q-banner v-if="bannerError" class="app-banner app-banner--error" dense rounded>
                    Erreur dans l'enregistrement
                </q-banner>

            </div>

        </div>
        
        <BetweenPageLoader v-if="betweenPage" />
    </div>
</template>
<script>
import Header from "../components/Header.vue";
import { ref, computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import axios from "axios";
import ResourceAssociator from "../components/ResourceAssociator.vue";
import { useRouter } from "vue-router";
import IntermediatePopup from "../components/IntermediatePopup.vue";
import BetweenPageLoader from "../components/BetweenPageLoader.vue";
import MediaManager from "../components/MediaManager.vue";
import QuizManager from "../components/QuizManager.vue";
import WorkflowBreadcrumb from "../components/WorkflowBreadcrumb.vue";
export default {
    components: {
        Header,
        ResourceAssociator,
        IntermediatePopup,
        BetweenPageLoader,
        MediaManager,
        QuizManager,
        WorkflowBreadcrumb
    },
    setup() {
        const store = useStore();
        const router = useRouter();
        let resourcesList = ref(false);
        let options = ref([]);
        let model = ref([]);
        let associator = ref(false);
        const selectedPointId = computed(() => store.state.pointSelected?.point_id)
        let mainResourceId = ref(null);
        let resourcesFromPoints = ref([]);
        let resources = ref([]);
        let selectedResource = ref(null);
        let displaySelected = ref(null);
        let bgSource = ref('color');
        let bgColor = ref(null);
        let bgImageId = ref(null);
        const getContrastingTextColor = (color) => {
            if (!color || typeof color !== 'string') return '#6b7280';
            const match = color.trim().match(/^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i);
            if (!match) return '#111827';
            const red = parseInt(match[1], 16);
            const green = parseInt(match[2], 16);
            const blue = parseInt(match[3], 16);
            const brightness = (red * 299 + green * 587 + blue * 114) / 1000;
            return brightness > 150 ? '#111827' : '#ffffff';
        };
        const selectedBgImageTitle = computed(() => {
            if (bgSource.value !== 'image' || !bgImageId.value) {
                return 'Aucune image';
            }
            const selectedImage = resources.value.find((resource) =>
                resource.id === bgImageId.value || resource.resource_id === bgImageId.value
            );
            return selectedImage ? (selectedImage.title || selectedImage.name || 'Image sélectionnée') : 'Image sélectionnée';
        });
        const overlayPreviewStyle = computed(() => {
            if (bgSource.value === 'color') {
                return {
                    backgroundColor: bgColor.value || '#f6f7f9',
                    color: getContrastingTextColor(bgColor.value),
                    borderColor: bgColor.value || '#d9dde5'
                };
            }
            return {
                background: 'linear-gradient(135deg, #f8fafc 0%, #eef2f7 100%)',
                color: '#4b5563',
                borderColor: '#d9dde5'
            };
        });
        let quizzes = ref([]);
        let quizSelectedId = ref(null);
        let quizManager = ref(false);
        const isQuizDisplay = computed(() => displaySelected.value === 'quiz' || displaySelected.value === 'quizFullPage');
        const success = ref(false);
        let source = ref("");
        let source_url = ref("");
        let title = ref("");
        let description = ref("");
        let loading = ref(false);
        let fileInput = ref(null);
        let fileName = ref(null);
        var intermediatePopupKey = ref(0);
        let isRefreshing = ref(false);
        const exhibitName = computed(() => store.state.exhibitName);
        let betweenPage = ref(false);
        let resourceAssociator = ref(null)
        let resourcesFiltered = ref();
        let bannerError = ref(false);
        let errorBanner = ref(false);
        let resourceAssociatorKey = ref(0)
        let column1 = ref(true);
        let column2 = ref(true);
        let column3 = ref(true);
        let uploading = ref(false);
        let progress = ref(0);
        let isDragging = ref(false);
        let selectedFiles = ref(null);
        let filesToUpload = ref([]);
        let uploadCurrent = ref(0);
        let uploadTotal = ref(0);
        let displayOptions = ref([
            { label: "Avant / Après", value: "avantApres" },
            { label: "Carousel", value: "carousel3D" },
            { label: "Comics snap", value: "comics" },
            { label: "Coverflow", value: "coverflow" },
            { label: "Diaporama", value: "diaporama" },
            { label: "Image + Audio", value: "imageAudio" },
            { label: "Lien", value: "link" },
            { label: "Livre", value: "flipBook" },
            { label: "Mosaïque", value: "mosaique" },
            { label: "Pellicule", value: "pellicule" },
            { label: "Quiz", value: "quiz" },
            { label: "Quiz pleine page", value: "quizFullPage" },
            { label: "Scroll", value: "scroll" },
            { label: "Slider", value: "negatifSlider" },
            { label: "Video", value: "video" },
            { label: "Document", value: "docx" }
        ]);



        const groupByPoints = (data) => {
            return data.reduce((acc, item) => {
                if (!acc[item.point_id]) {
                    acc[item.point_id] = [];
                }
                acc[item.point_id].push(item);
                return acc;
            }, {});
        };

        const getUniquePoints = (groupedData) => {
            return Object.values(groupedData)
                .filter((items) => items[0].point_id && items[0].name)
                .map((items) => ({
                    point_id: items[0].point_id,
                    name: items[0].name
                }))
                .filter((item, index, self) =>
                    index === self.findIndex((t) => t.point_id === item.point_id)
                );
        };

        const handleSelectedResource = (resource) => {
            console.log("Fichier selectionné", resource)
            selectedResource.value = resource;
            getStyleFromPoint();
        }

        const getQuizzes = async () => {
            try {
                let url = `${process.env.VUE_APP_BASEURL}/quizzes/${store.state.exhibitId}`;
                let response = await axios.get(url);
                quizzes.value = response.data;
            } catch (error) {
                console.log(error);
            }
        }
        getQuizzes();

        const getSelectedResourceId = () => {
            const resourceId = selectedResource.value?.resource_id ?? selectedResource.value?.id;
            return resourceId === undefined || resourceId === null ? null : Number(resourceId);
        }

        const clearAssociationsForSelectedResource = async (resourceId) => {
            if (!resourceId || !selectedPointId.value) return;
            await axios.post(`${process.env.VUE_APP_BASEURL}/resourceAssociation`, {
                mainResourceId: resourceId,
                associatedResourcesIds: [],
                pointId: Number(selectedPointId.value),
            });
        }

        const getStyleFromPoint = async () => {
            try {
                const resourceId = getSelectedResourceId();
                if (!resourceId || !selectedPointId.value) return;
                let url = `${process.env.VUE_APP_BASEURL}/style/${resourceId}/${selectedPointId.value}`;
                let response = await axios.get(url);
                if (response.data.length > 0 && response.data[0].style) {
                    displaySelected.value = response.data[0].style;
                    bgColor.value = response.data[0].bg_color || null;
                    bgImageId.value = response.data[0].bg_image_id || null;
                    bgSource.value = bgImageId.value ? 'image' : 'color';
                    quizSelectedId.value = response.data[0].quiz_id || null;
                } else {
                    displaySelected.value = 'negatifSlider';
                    bgColor.value = null;
                    bgImageId.value = null;
                    bgSource.value = 'color';
                    quizSelectedId.value = null;
                }

            } catch (error) {
                console.log(error);
            }
        }

        const getPoints = async (retries = MAX_RETRIES) => {
            const BASE_URL = process.env.VUE_APP_BASEURL;
            const url = `${BASE_URL}/pointsFromMainResource/${mainResourceId.value}`;

            if (!mainResourceId.value) {
                console.error("Missing mainResourceId.value.");
                return;
            }

            // Définition d'une promesse de timeout
            let timeoutPromise = new Promise((_, reject) => {
                setTimeout(() => reject(new Error("Request timeout")), TIMEOUT_DELAY);
            });

            try {
                // Exécution de la requête Axios et de la promesse de timeout en parallèle
                const response = await Promise.race([
                    axios.get(url),
                    timeoutPromise
                ]);

                if (response.data && Array.isArray(response.data)) {
                    const groupedData = groupByPoints(response.data);
                    resourcesFromPoints.value = groupedData;
                    store.commit("SET_RESOURCESFROMPOINTS", resourcesFromPoints);

                    options.value = getUniquePoints(groupedData);
                } else {
                    console.warn("Unexpected response format or no data received from the server.");
                }

            } catch (error) {
                console.error("Error fetching points:", error.message);

                if (retries > 0) {
                    console.log(`Retrying in ${RETRY_DELAY / 1000} seconds. Remaining attempts: ${retries}`);
                    setTimeout(() => getPoints(retries - 1), RETRY_DELAY);
                } else {
                    console.error("All attempts to fetch points have failed.");
                }
            }
        };


        const reloadComponent = () => {
            isRefreshing.value = true; // Afficher le loader externe
            intermediatePopupKey.value++;
            var temp = selectedResource.value;
            selectedResource.value = {};
            setTimeout(() => {
                selectedResource.value = temp
                // Masquer le loader après un délai suffisant pour tout charger
                setTimeout(() => {
                    isRefreshing.value = false;
                }, 3000); // 3s pour être sûr que tout est chargé
            }, 2000)

        }

        const openAssociator = () => {
            associator.value = true;
        }

        const selectFile = (event) => {
            const MAX_SIZE = 10000000; // Taille maximale du fichier en octets (10MB dans cet exemple)
            const file = event.target.files[0];

            if (file.size > MAX_SIZE) {
                alert("Le fichier est trop grand, le chargement peut être long.");
            }
            fileInput.value = event.target.files[0];
            if (event.target.files.length != 0) {
                fileName.value = event.target.files[0].name;
                let nameWithoutExtension = fileName.value.replace(/\.[^/.]+$/, "");  // Retire l'extension
                title.value = nameWithoutExtension;
            }
        };

        const getFileIcon = (name) => {
            if (!name) return 'insert_drive_file';
            const ext = name.split('.').pop().toLowerCase();
            if (['jpg','jpeg','png','gif','svg','webp','bmp','tiff'].includes(ext)) return 'image';
            if (['mp4','avi','mov','wmv','webm','mkv'].includes(ext)) return 'videocam';
            if (['mp3','wav','ogg','flac','aac'].includes(ext)) return 'audiotrack';
            if (['doc','docx'].includes(ext)) return 'description';
            return 'insert_drive_file';
        };

        const addFiles = (files) => {
            const MAX_SIZE = 10000000;
            for (const file of files) {
                if (file.size > MAX_SIZE) {
                    alert(`"${file.name}" est volumineux, le chargement peut être long.`);
                }
                filesToUpload.value.push({
                    file,
                    title: file.name.replace(/\.[^/.]+$/, ''),
                    description: '',
                    source: '',
                    source_url: '',
                });
            }
        };

        const onDrop = (event) => {
            isDragging.value = false;
            const files = event.dataTransfer.files;
            if (files.length > 0) addFiles(files);
        };

        const onFilesSelected = (files) => {
            if (files && files.length > 0) {
                addFiles(files);
                selectedFiles.value = null;
            }
        };

        const importFiles = async () => {
            if (filesToUpload.value.length === 0) return;
            try {
                uploading.value = true;
                loading.value = true;
                uploadTotal.value = filesToUpload.value.length;

                for (let i = 0; i < filesToUpload.value.length; i++) {
                    uploadCurrent.value = i + 1;
                    progress.value = 0;

                    const item = filesToUpload.value[i];
                    let formData = new FormData();
                    formData.append("file", item.file);
                    formData.append("name", item.file.name);
                    formData.append("title", item.title);
                    formData.append("description", item.description);
                    if (item.source) formData.append("source", item.source);
                    if (item.source_url) formData.append("source_url", item.source_url);
                    formData.append("exhibitId", store.state.exhibitId);
                    formData.append("index", store.state.resourcesCount);

                    let url = `${process.env.VUE_APP_BASEURL}/file`;
                    await axios.post(url, formData, {
                        headers: { 'Content-Type': 'multipart/form-data' },
                        onUploadProgress: (progressEvent) => {
                            if (progressEvent.lengthComputable) {
                                progress.value = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                            }
                        }
                    });
                }

                uploading.value = false;
                loading.value = false;
                filesToUpload.value = [];
                success.value = true;
                setTimeout(async () => {
                    success.value = false;
                    await getResources();
                    await getResourcesFromPoints();
                    if (resourceAssociator.value) {
                        await resourceAssociator.value.fetchResourcesFromPoint();
                    }
                    setTimeout(() => {
                        filterResources();
                        reloadComponent();
                    }, 1000);
                }, 4000);
            } catch (error) {
                console.log(error);
                errorBanner.value = true;
                uploading.value = false;
                setTimeout(() => {
                    errorBanner.value = false;
                    loading.value = false;
                }, 1500);
            }
        };

        const MAX_RETRIES = 3;
        const RETRY_DELAY = 2000; // en millisecondes (2 secondes ici)
        const TIMEOUT_DELAY = 5000; // en millisecondes (5 secondes ici)

        const getMainResource = async (retries = MAX_RETRIES) => {
            try {
                let url = `${process.env.VUE_APP_BASEURL}/mainresource/${store.state.exhibitId}`;

                // Définition d'une promesse de timeout
                let timeoutPromise = new Promise((_, reject) => {
                    setTimeout(() => reject(new Error("Request timeout")), TIMEOUT_DELAY);
                });

                // Exécution de la requête Axios et de la promesse de timeout en parallèle
                let response = await Promise.race([
                    axios.get(url),
                    timeoutPromise
                ]);

                // Récupération de l'id de la page principale
                mainResourceId.value = response.data[0].main_resource_id;

            } catch (error) {
                console.error("Erreur lors de la récupération de la ressource principale :", error.message);

                if (retries > 0) {
                    console.log(`Nouvelle tentative dans ${RETRY_DELAY / 1000} secondes. Tentatives restantes : ${retries}`);
                    setTimeout(() => getMainResource(retries - 1), RETRY_DELAY);
                } else {
                    console.error("Toutes les tentatives de récupération de la ressource principale ont échoué.");
                }
            }
        };



        const getResources = async () => {
            try {
                let url = `${process.env.VUE_APP_BASEURL}/resources/${store.state.exhibitId}`;
                let response = await axios.get(url);
                resources.value = response.data;
            } catch (error) {
                console.log(error)
            }
        }

        const getResourcesFromPoints = async () => {
            try {
                let url = `${process.env.VUE_APP_BASEURL}/pointsFromMainResource/${mainResourceId.value}`;
                let response = await axios.get(url);
                var outputJSON = {};
                response.data.forEach(function (item) {
                    if (
                        !Object.prototype.hasOwnProperty.call(outputJSON, item.point_id)
                    ) {
                        outputJSON[item.point_id] = [];
                    }
                    outputJSON[item.point_id].push(item.resource_id);
                });
                resourcesFromPoints.value = outputJSON;
            } catch (error) {
                console.log(error);
            }
        };

        const filterResources = () => {
            resourcesFiltered.value = resources.value.filter(resource =>
                resourcesFromPoints.value[selectedPointId.value].includes(resource.id)

            )
        }

        const navigateBack = () => {
            router.go(-1);
        }

        const navigateToExhibits = () => {
            router.push("/admin");
        }

        const navigateToResourceManagement = () => {
            router.push("/resourceManagement");
        }

        const finalSave = async () => {
            try {
                console.log("Début de finalSave");
                betweenPage.value = true;
                
                // Créer un timer de sécurité pour garantir la navigation après un délai maximal
                const safetyTimer = setTimeout(() => {
                    console.log("⚠️ Timer de sécurité exécuté - forçage de la navigation");
                    betweenPage.value = false;
                    navigateToResourceManagement();
                }, 8000); // 8 secondes maximum
                
                console.log("Exécution de saveStyle");
                const styleSaved = await saveStyle();
                console.log("saveStyle terminé", styleSaved);
                if (!styleSaved) {
                    clearTimeout(safetyTimer);
                    betweenPage.value = false;
                    return;
                }
                
                console.log("Exécution de associateResources");
                if (!isQuizDisplay.value && resourceAssociator.value) {
                    const success = await resourceAssociator.value.associateResources();
                    console.log("associateResources terminé avec succès:", success);
                    
                    // Si l'association échoue, on pourrait quand même continuer
                    if (!success) {
                        console.warn("associateResources a échoué mais on continue la navigation");
                    }
                } else if (isQuizDisplay.value) {
                    console.log("Quiz sélectionné : aucune association de ressources nécessaire");
                } else {
                    console.error("resourceAssociator est null ou undefined");
                }
                
                console.log("Configuration du timeout pour la navigation");
                setTimeout(() => {
                    // Annuler le timer de sécurité puisque tout s'est bien passé
                    clearTimeout(safetyTimer);
                    
                    console.log("Timeout exécuté, navigation en cours");
                    betweenPage.value = false;
                    navigateToResourceManagement();
                }, 3000);
            } catch (error) {
                console.error("Erreur dans finalSave:", error);
                betweenPage.value = false; // Toujours désactiver le loader en cas d'erreur
                
                // Afficher un message d'erreur à l'utilisateur
                bannerError.value = true;
                setTimeout(() => {
                    bannerError.value = false;
                }, 3000);
                
                // Tenter quand même la navigation après l'erreur
                setTimeout(() => {
                    navigateToResourceManagement();
                }, 4000);
            }
        }

        const saveStyle = async () => {
            try {
                console.log("Début de saveStyle");
                
                // Vérifier si une ressource est sélectionnée
                if (!selectedResource.value) {
                    console.warn("Aucune ressource sélectionnée pour saveStyle");
                    return true; // On peut continuer sans sauvegarder le style
                }
                
                const resourceId = getSelectedResourceId();
                if (!resourceId) {
                    console.warn("Aucune ressource sélectionnée pour saveStyle");
                    return true;
                }

                if (isQuizDisplay.value && !quizSelectedId.value) {
                    console.warn("Aucun quiz sélectionné pour le style quiz");
                    bannerError.value = true;
                    setTimeout(() => {
                        bannerError.value = false;
                    }, 3000);
                    return false;
                }

                var body = {
                    resourceId,
                    style: displaySelected.value || "",
                    pointId: Number(selectedPointId.value),
                    bgColor: bgSource.value === 'color' ? bgColor.value : null,
                    bgImageId: bgSource.value === 'image' ? bgImageId.value : null,
                    quizId: isQuizDisplay.value ? Number(quizSelectedId.value) : null
                }
                console.log("Sauvegarde du style:", body);
                
                let url = `${process.env.VUE_APP_BASEURL}/resourceStyle`;
                const response = await axios.post(url, body);
                if (isQuizDisplay.value) {
                    await clearAssociationsForSelectedResource(resourceId);
                }
                console.log("Réponse de saveStyle:", response.status);
                
                success.value = true;
                setTimeout(() => {
                    success.value = false;
                    reloadComponent();
                }, 4000);
                
                return true;
            } catch (error) {
                console.error("Erreur dans saveStyle:", error);
                errorBanner.value = true;
                setTimeout(() => {
                    errorBanner.value = false;
                }, 4000);
                
                return false;
            }
        }

        const importImage = async () => {
            try {
                loading.value = true;
                uploading.value = true;
                progress.value = 0;
                let formData = new FormData();
                formData.append("file", fileInput.value);
                formData.append("name", fileName.value);
                formData.append("description", description.value);
                formData.append("title", title.value);
                formData.append("exhibitId", store.state.exhibitId);
                formData.append("index", store.state.resourcesCount);
                formData.append('source', source.value);
                formData.append('source_url', source_url.value);
                let url = `${process.env.VUE_APP_BASEURL}/file`;
                var response = await axios.post(url, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });
                console.log(response.data)
                if (response.status == 200) {
                    loading.value = false;
                    success.value = true;
                    uploading.value = false;
                    progress.value = 100;
                    setTimeout(async () => {
                        success.value = false;
                        fileInput.value.value = null;
                        fileName.value = "";
                        description.value = "";
                        title.value = "";
                        source.value = "";
                        source_url.value = "";
                        
                        // Recharger les ressources
                        await getResources();
                        await getResourcesFromPoints();

                        // Mettre à jour le composant ResourceAssociator
                        if (resourceAssociator.value) {
                            await resourceAssociator.value.fetchResourcesFromPoint();
                        }
                        
                        // Mettre à jour la prévisualisation
                        // IntermediatePopup sera mis à jour via l'événement selectedResource émis par ResourceAssociator
                        
                        // Mettre à jour les ressources filtrées
                        setTimeout(() => {
                            filterResources();
                            reloadComponent();

                        }, 1000)
                    }, 4000);
                }
            } catch (err) {
                console.log(err);
                errorBanner.value = true;
                setTimeout(() => {
                    errorBanner.value = false;
                    loading.value = false;
                    success.value = false;
                    fileInput.value.value = null;
                    intermediatePopupKey.value++;
                    fileName.value = "";
                    description.value = "";
                    title.value = "";
                    source.value = "";
                    source_url.value = "";
                }, 4000);

            }
        }

        const openNewTab = () => {
            window.open(store.getters.exhibitUrl, "_blank");
        }

        const navigateToExpo_bu = () => {
            router.push({ path: `/expo/${store.state.exhibitId}` });
        }

        const navigateToCreation = () => {
            router.push({ path: `/creation` });
        }

        const navigateToAddPoint = () => {
            router.push({ path: `/point` });
        }

        const navigateToIntermediate = () => {
            router.push("/resourceManagement")
        }



        onMounted(async () => {
            await getMainResource();
            await getPoints();
            await getResources();
            await getResourcesFromPoints();
            setTimeout(() => {
                filterResources();

            }, 1000)
        });



        return {
            resourcesList,
            options,
            model,
            associator,
            selectedPointId,
            mainResourceId,
            displayOptions,
            selectedResource,
            resources,
            displaySelected,
            bgSource,
            bgColor,
            bgImageId,
            selectedBgImageTitle,
            overlayPreviewStyle,
            quizzes,
            quizSelectedId,
            quizManager,
            isQuizDisplay,
            getQuizzes,
            success,
            loading,
            title,
            description,
            fileInput,
            fileName,
            source,
            source_url,
            intermediatePopupKey,
            isRefreshing,
            exhibitName,
            betweenPage,
            resourceAssociator,
            resourcesFiltered,
            bannerError,
            errorBanner,
            resourceAssociatorKey,
            getPoints,
            openAssociator,
            navigateBack,
            saveStyle,
            importImage,
            selectFile,
            openNewTab,
            finalSave,
            navigateToExhibits,
            navigateToExpo_bu,
            navigateToAddPoint,
            navigateToCreation,
            navigateToIntermediate,
            reloadComponent,
            handleSelectedResource,
            column1,
            column2,
            column3,
            uploading,
            progress,
            isDragging,
            selectedFiles,
            filesToUpload,
            uploadCurrent,
            uploadTotal,
            getFileIcon,
            onDrop,
            onFilesSelected,
            importFiles
        }
    }
}
</script>
<style scoped>
.container {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
}

.column {
    flex: 1;
    margin: 10px;
    padding: 20px;
    border: 1px solid #ccc;
    border-radius: 10px;
    background: #ffffff;
}

.column h4 {
    display: flex;
    align-items: center;
    gap: 8px;
    margin: 0 0 16px;
    color: #111827;
    font-size: 20px;
    font-weight: 600;
    line-height: 1.25;
}

.navButtons {
    display: flex;
    justify-content: space-between;
}

.banner {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 99999;

    /* Design */
    padding: 15px 30px;
    border-radius: 5px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);

    /* Typographie */
    font-size: 16px;
    font-family: 'Helvetica', sans-serif;
    /* Remplacez par la police de votre choix */

    /* Transition */
    transition: all 0.3s ease-in-out;
}

.infos {
    font-size: 16px;
    border: 1px solid gray;
    width: 70%;
    margin: auto;
    margin-bottom: 5px;
    border-radius: 5px;
}

.title {
    display: flex;
    align-items: center;
    font-size: 1.2 rem;
    margin-left: 1%;
}

.flex-column {
    max-width: 600px;
    min-width: 300px;
    margin: 0 10px;
}

/* Espacement entre les blocs d'une même colonne. */
.column-section + .column-section {
    margin-top: 24px;
}

.animation-editor {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.animation-editor__header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 12px;
}

.animation-editor__title {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    min-width: 0;
}

.animation-editor__title > .q-icon {
    color: #000;
    font-size: 22px;
}

.animation-editor__title h4 {
    margin-bottom: 2px;
}

.animation-editor__resource {
    display: block;
    max-width: 100%;
    color: #6b7280;
    font-size: 13px;
    line-height: 1.3;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.animation-editor__field {
    width: 100%;
}

.overlay-settings {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.overlay-settings__top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
}

.overlay-settings__label {
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 0;
    color: #111827;
    font-size: 15px;
    font-weight: 600;
}

.overlay-settings__label .q-icon {
    color: #000;
    font-size: 20px;
}

.overlay-settings__toggle {
    flex: 0 0 auto;
    border: 1px solid #dce1ea;
    border-radius: 4px;
    overflow: hidden;
    box-shadow: none;
}

.overlay-settings__body {
    display: grid;
    grid-template-columns: minmax(0, 1fr) 160px;
    gap: 12px;
    align-items: stretch;
}

.overlay-settings__control {
    min-width: 0;
}

.color-swatch {
    width: 22px;
    height: 22px;
    border: 1px solid #cfd5df;
    border-radius: 0;
    box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.55);
}

.overlay-preview {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    min-width: 0;
    min-height: 40px;
    padding: 0 12px;
    border: 1px solid;
    border-radius: 0;
    font-size: 13px;
    font-weight: 600;
    line-height: 1.2;
    text-align: center;
    overflow: hidden;
}

.overlay-preview span {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.quiz-settings {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    gap: 10px;
    align-items: center;
}

.quiz-settings__button {
    height: 40px;
    white-space: nowrap;
}

.animation-editor__actions {
    display: flex;
    justify-content: flex-end;
    padding-top: 2px;
}

@media (max-width: 760px) {
    .container {
        padding: 0 12px 20px;
    }

    .column {
        min-width: 0;
        width: 100%;
        max-width: none;
    }

    .quiz-settings {
        grid-template-columns: 1fr;
    }

    .overlay-settings__top {
        align-items: stretch;
        flex-direction: column;
    }

    .overlay-settings__toggle {
        width: 100%;
    }

    .overlay-settings__body {
        grid-template-columns: 1fr;
    }

    .animation-editor__actions {
        justify-content: stretch;
    }

    .animation-editor__actions .q-btn {
        width: 100%;
    }
}

.upload-loader {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(250, 250, 250, 0.98);
    z-index: 11000;
    display: flex;
    align-items: center;
    justify-content: center;
    backdrop-filter: blur(4px);
}

.upload-loader-card {
    background: #ffffff;
    padding: 48px 64px;
    border-radius: 16px;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
    border: 1px solid #e5e5e5;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.upload-loader-text {
    margin: 0;
    color: #4a4a4a;
    font-size: 15px;
    font-weight: 500;
    letter-spacing: 0.3px;
}

.progress-container {
    width: 200px;
    height: 4px;
    background: #e5e5e5;
    border-radius: 2px;
    margin-top: 20px;
    overflow: hidden;
}

.progress-bar {
    height: 100%;
    background: #2c2c2c;
    transition: width 0.3s ease;
    border-radius: 2px;
}

.progress-text {
    margin: 8px 0 0 0;
    color: #6a6a6a;
    font-size: 13px;
    font-weight: 500;
}

.column-toggle-container {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}

.refresh-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(250, 250, 250, 0.98);
    z-index: 100000;
    display: flex;
    align-items: center;
    justify-content: center;
    backdrop-filter: blur(4px);
}

.refresh-loader {
    background: #ffffff;
    padding: 48px 64px;
    border-radius: 16px;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border: 1px solid #e5e5e5;
}

.spinner-container {
    display: flex;
    gap: 12px;
    margin-bottom: 24px;
}

.spinner-dot {
    width: 12px;
    height: 12px;
    background: #2c2c2c;
    border-radius: 50%;
    animation: bounce 1.4s infinite ease-in-out both;
}

.spinner-dot:nth-child(1) {
    animation-delay: -0.32s;
}

.spinner-dot:nth-child(2) {
    animation-delay: -0.16s;
}

@keyframes bounce {
    0%, 80%, 100% {
        transform: scale(0.8);
        opacity: 0.5;
    }
    40% {
        transform: scale(1.2);
        opacity: 1;
    }
}

.refresh-text {
    margin: 0;
    color: #4a4a4a;
    font-size: 15px;
    font-weight: 500;
    letter-spacing: 0.3px;
}

.drop-zone {
  border: 2px dashed #bdbdbd;
  border-radius: 8px;
  padding: 24px;
  text-align: center;
  transition: border-color 0.2s, background-color 0.2s;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.drop-zone--active {
  border-color: #1976d2;
  background-color: rgba(25, 118, 210, 0.06);
}
</style>
